<script setup>
import { defineModel } from 'vue'

const user = defineModel('user')
</script>

<template>
    <div class="w-1/3 flex flex-col">
        <div class="flex flex-col">
            <div class="my-6 flex justify-center items-center">
                <span class="font-bold text-gray-600 text-base">Аккаунты</span>
            </div>
            <div class="h-24 bg-gray-200 flex items-center">
                <div class="flex w-full h-4/5 items-center">
                    <div class="w-16 h-16 bg-white flex justify-center items-center rounded-xl mx-5">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1399.79 1250.67" class="w-10 h-10"><path d="M125.83,1071.89l61.73,106.63c12.82,22.44,31.26,40.08,52.91,52.91L460.94,849.81H20A145.24,145.24,0,0,0,39.24,922Z" transform="translate(-20)" style="fill: rgb(0, 102, 218);"></path><path d="M719.89,400.86,499.42,19.24c-21.64,12.83-40.08,30.47-52.91,52.91L39.24,777.66A145.31,145.31,0,0,0,20,849.81H460.94Z" transform="translate(-20)" style="fill: rgb(0, 172, 71);"></path><path d="M1199.32,1231.43c21.64-12.83,40.08-30.47,52.91-52.91l25.65-44.1L1400.55,922a145.34,145.34,0,0,0,19.24-72.16h-441l93.84,184.4Z" transform="translate(-20)" style="fill: rgb(234, 67, 53);"></path><path d="M719.89,400.86,940.36,19.24C918.72,6.41,893.87,0,868.21,0H571.58c-25.66,0-50.51,7.22-72.16,19.24Z" transform="translate(-20)" style="fill: rgb(0, 131, 45);"></path><path d="M978.85,849.81H460.94L240.47,1231.43c21.65,12.83,46.5,19.24,72.15,19.24h814.54c25.66,0,50.51-7.22,72.16-19.24Z" transform="translate(-20)" style="fill: rgb(38, 132, 252);"></path><path d="M1196.91,424.91,993.28,72.15C980.45,49.71,962,32.07,940.36,19.24L719.89,400.86l259,448.95H1419a145.24,145.24,0,0,0-19.25-72.15Z" transform="translate(-20)" style="fill: rgb(255, 186, 0);"></path></svg>
                    </div>
                    <div class="flex flex-col">
                        <div class="font-bold text-xl">
                            Google Drive
                        </div>
                        <div v-if="user?.google_account !== null">
                            {{ user?.google_account?.email }}
                        </div>
                        <div v-else class="font-sm text-blue-500 cursor-pointer select-none px-2 py-1 hover:bg-gray-200 rounded-md transition-all duration-150">
                            + Добавить аккаунт
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-4/5 mt-auto mx-auto mb-5">
            <div class="mb-1">
                Tegrum не хранит копии данных ваших файлов
            </div>
            <div>
                Прочитайте наше <span class="underline underline-offset-1 cursor-pointer">пользовательское соглашение</span>
            </div>
        </div>
    </div>
</template>
